import React from 'react';
import { Formik } from 'formik';
import { Box, List, Typography } from '@mui/material';
import { WeekDayKeys } from '@uplift/types';
import { Button } from '@uplift/ui-v2';
import { useL10n } from '@uplift/hooks';
import { CheckboxListItemField } from './CheckboxListItem';


export const CopyAvailabilityForm: React.FC<{
  weekDay: WeekDayKeys;
  onClose: () => void;
  onSubmit: (data: Partial<Record<WeekDayKeys, boolean>>) => void;
}> = (props) => {
  const l10n = useL10n();

  return (
    <Formik
      initialValues={{ [props.weekDay]: true } as Partial<Record<WeekDayKeys, boolean>>}
      onSubmit={async values => {
        props.onClose();
        props.onSubmit(values);
      }}
    >
      {_formik => (
        <>
          <Box p={2} pb={0}>
            <Typography variant="body1" color="textPrimary">
              Copy times to:
            </Typography>
          </Box>
          <List>
            {l10n.general.weekday.map(w =>
              <CheckboxListItemField key={w} name={w.toUpperCase()} disabled={w.toUpperCase() === props.weekDay} label={w} />
            )}
          </List>
          <Box px={1} pb={2}>
            <Button onClick={_formik.handleSubmit} size="small" color="primary" variant="contained" fullWidth>{l10n.general.apply}</Button>
          </Box>
        </>
      )}
    </Formik>
  );
};
